import { compose, applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from './reducer'

const logger = createLogger({
    collapsed: true
})

const composedStore = compose(
    applyMiddleware(thunk),
    applyMiddleware(logger),
    window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore)

const configureStore = (initialState) => {

    let store = composedStore(reducer, initialState)

    if (module.hot) {
        module.hot.accept('./reducer', () => {
            const nextReducer = require('./reducer')
            store.replaceReducer(nextReducer)
        })
    }

    return store
}

export default configureStore



// WEBPACK FOOTER //
// ./client/store.js